import { render } from "./CardFlashcardView.vue?vue&type=template&id=6d8b8a27&scoped=true"
import script from "./CardFlashcardView.vue?vue&type=script&lang=js"
export * from "./CardFlashcardView.vue?vue&type=script&lang=js"

import "./CardFlashcardView.vue?vue&type=style&index=0&id=6d8b8a27&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8b8a27"]])

export default __exports__